
import { Options, Vue } from "vue-class-component";
import ProductService from "../../service/ProductService.js";
import StockService from "../../service/StockService.js";
import { reactive } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Toaster from "../../helpers/Toaster";
import moment from "moment";
import { useStore, ActionTypes } from "../../store";
import FileUploader from "../../components/FileUploader.vue";
import Dialog from "primevue/dialog";
import { ref } from "vue";
import ProductForm from "../../components/ProductForm.vue";
import PermissionsService from "../../service/PermissionService.js";

@Options({
    title: "Products",
    components: {
        FileUploader,
        ProductForm,
    },
})
export default class Products extends Vue {
    private store = useStore();
    private lists = [];
    private fullLists = [];
    private dialogTitle;
    private finallyClickedPage = 0;
    private toast;
    private goToFirstLink = 0;
    private enableEditButton = false;
    private goToThirdLink = 2;
    private currentStoreID = 0;
    private productService;
    private stockService;
    private productDialog = false;
    private submitted = false;
    private deleteConfirmationDialog = false;
    private keyword = "";
    private checkPagination = true;
    private totalRecords = 0;
    private limit = 0;
    private home = { icon: "pi pi-home", to: "/" };
    private items = [
        { label: "Initialization", to: "initialization" },
        { label: "Product Management", to: "products" },
    ];
    private uploaderStatus = false;
    private prodUploaderStatus = false;
    private productType;
    private brand;
    private unit;
    private brandSector;
    private category;
    private totalInValid = 0;
    private totalValid = 0;
    private duplicateRefItems: string[] = [];
    private nullRefItems: number[] = [];
    private nullIDItems: number[] = [];
    private duplicateIDs: number[] = [];
    private invalidIDsBool: boolean = false;
    private existingRecord: boolean = false;
    private invalidMinStockItems: number[] = [];
    private invalidRefItems: number[] = [];
    private editingRow = null;
    private limitation = 20;
    private products = []; // Array to store saved products
    private firstEditingRowTemp = 0;
    private permission;
    private lastReference;
    //private partOfDataArray =
    private item = {
        id: 0,
        barcode: "",
        description: "",
        image: "default.jpg",
        sideEffects: "",
        packSelling: 0,
        tax_1: 0,
        tax_2: 0,
        tax_3: 0,
        status: "Active",
    };

    private state = reactive({
        productName: "",
        generic: "",
        productType: 0,
        brand: 0,
        unit: 0,
        brandSector: 0,
        category: 0,
        stripSize: 0,
        packSize: 0,
        batchNo: "",
        unitQty: 0,
        packPurchase: 0,
        mRP: 0,
        disc: 0,
        expiryDate: "",
        storeLocation: "",
        supplier: "",
        minStock: 0,
    });

    private excelFileContent = [
        {
            id: 0,
            productName: "",
            genericName: "",
            commonName: "",
            reference: "",
            minStock: 0,
            productLocation: "",
        },
    ];
    private downloadExcelFileContent = [
        {
            id: 0,
            productName: "",
            genericName: "",
            commonName: "",
            reference: "",
            minStock: 0,
            productLocation: "",
        },
    ];

    private oneFullDataRow = [
        {
            productName: "",
            genericName: "",
            commonName: "",
            reference: "",
            minStock: 0,
            productLocation: "",
            barcode: "",
            unitName: "",
            unitValue: 0,
            prescription: 0,
            insurance: 0,
            expirable: 0,
            typeId: 0,
            brandId: 0,
            brandSectorId: 0,
            categoryid: 0,
            sideEffects: "",
            description: "",
        },
    ];
    private errorDialog = false;

    private storeList = [];
    private selectedStore = {
        id: 0,
    };

    public handleSearch(): void {
        if (this.keyword.trim() !== "") {
            this.loadSearchData();
        } else {
            this.loadList(0);
        }
    }

    confirmDeleteItem(data) {
        this.state.productName = data.product_name;
        this.item.id = data.id;
        this.deleteConfirmationDialog = true;
    }

    handleClick() {
        this.checkProductInStock(this.item);
    }
    checkProductInStock(data) {
        this.stockService.getItem(data).then((res) => {
            if (res.product_id == data.id) {
                this.existingRecord = true;
                this.deleteConfirmationDialog = false;
                this.errorDialog = true;
            } else {
                this.deleteItem();
            }
        });
    }
    deleteItem() {
        this.deleteConfirmationDialog = false;
        this.productService.deleteItem(this.item.id).then((res) => {
            let eventFirstPara = this.limit * this.finallyClickedPage;
            this.loadList(eventFirstPara);
            this.toast.handleResponse(res);
        });
    }

    getProductTypeById(id) {
        const item = this.productType.find((product) => product.id === id);

        return item ? item.option_name : null;
    }
    getBrandNameById(id) {
        const item = this.brand.find((brand) => brand.id === id);

        return item ? item.option_name : null;
    }
    getUnitNameById(id) {
        let item;
        if (id) {
            item = this.unit.find((unit) => unit.id == id);
            return item.option_name;
        } else {
            return "";
        }
    }
    getBrandSectorById(id) {
        const item = this.brandSector.find(
            (brandSector) => brandSector.id === id
        );

        return item ? item.option_name : null;
    }
    getCategoryById(id) {
        const item = this.category.find((category) => category.id === id);
        return item ? item.option_name : null;
    }
    //CALLING WHEN PAGINATION BUTTON CLICKS
    onPage(event) {
        this.enableEditButton = true;
        this.loadList(event.first);
        this.finallyClickedPage = event.page;
    }

    //DEFAULT METHOD OF TYPE SCRIPT
    //CALLING WHENEVER COMPONENT LOADS
    created() {
        this.productService = new ProductService();
        this.stockService = new StockService();
        this.toast = new Toaster();
    }

    //CALLNING AFTER CONSTRUCTOR GET CALLED
    mounted() {
        this.loadList(0);
        // this.loadFullList();

        this.permission = new PermissionsService();
    }

    get deleteProduct() {
        if (this.permission.can("delete_product")) {
            return true;
        }
        return false;
    }
    get addUpdateProduct() {
        this.permission = new PermissionsService();
        if (this.permission.can("add_update_products")) {
            return true;
        }
        return false;
    }
    loadList(page) {
        this.productService
            .getProducts(
                this.keyword,
                this.selectedStore.id,
                page,
                this.limitation
            )
            .then((data) => {
                this.lists = data.records;
                this.totalRecords = data.totalRecords;
                this.limit = data.limit;
                this.productType = data.productType;
                this.brand = data.brand;
                this.unit = data.unit;
                this.brandSector = data.brandSector;
                this.category = data.category;
                this.lastReference = data.lastReference;
            });
    }

    loadFullList() {
        this.productService.getProducts("", 0, 0, 0).then((data) => {
            this.fullLists = data.records;

            if (this.fullLists.length > 0) {
                this.downloadExcelFileContent = [];

                this.fullLists.forEach((e: any, index) => {
                    this.downloadExcelFileContent.push({
                        id: e.id, // Assign id as index + 1
                        productName: e.product_name,
                        genericName: e.generic_name,
                        commonName: e.common_name,
                        reference: e.reference,
                        minStock:
                            e.min_stock !== null &&
                            e.min_stock !== undefined &&
                            e.min_stock !== ""
                                ? e.min_stock
                                : 0,
                        productLocation: e.product_location,
                    });
                });
            }
        });
    }

    clearItems() {
        this.item = {
            id: 0,
            barcode: "",
            description: "",
            image: "default.jpg",
            sideEffects: "",
            packSelling: 0,
            tax_1: 0,
            tax_2: 0,
            tax_3: 0,
            status: "Active",
        };

        this.state.stripSize = 0;
        this.state.packSize = 0;
        this.state.batchNo = "";
        this.state.unitQty = 0;
        this.state.packPurchase = 0;
        this.state.mRP = 0;
        this.state.disc = 0;
        this.state.minStock = 0;
        this.state.expiryDate = "";
        this.state.storeLocation = "";
        this.state.supplier = "";
    }

    fixDigits(amt) {
        return Number(amt).toFixed(2);
    }

    formatExpiry(date) {
        return moment(date).format("MM-YYYY");
    }

    formatDateTime(date) {
        return moment(date).format("DD-MM-YYYY hh:mm A");
    }

    loadSearchData() {
        this.submitted = true;
        if (this.keyword) {
            this.goToFirstLink = 0;
            this.loadList(0);
        }
    }

    openFileUploader() {
        this.uploaderStatus = true;
    }

    openProductUploader() {
        this.prodUploaderStatus = true;
    }

    updateProductUploader(params){
        this.prodUploaderStatus = false;
        if (params.length > 0) {
            this.excelFileContent = [];

            this.productService.uploadProducts(params[0]).then((res) => {
                if(res.status_id == 1){
                    this.toast.handleResponse(res);
                } else {
                    this.toast.handleResponse(res);
                }
                
            });
        }
    }

    updateUploaderStatus(params) {
        this.invalidIDsBool = false;
        this.uploaderStatus = false;
        if (params.length > 0) {
            this.excelFileContent = [];

            this.productService.uploadCSVFile(params[0]).then((res) => {
                if (res.length > 0) {
                    const expectedHeaders = [
                        "Product ID(*)",
                        "Product Name(*)",
                        "Generic Name(*)",
                        "Common Name(*)",
                        "Reference(*)",
                        "Min Stock",
                        "Product Location",
                    ];


                    const uploadedHeaders = res[0].map((header) =>
                        String(header).trim()
                    ); // Trim to avoid spaces
                    const headersMatch = expectedHeaders.every(
                        (header, index) => header === uploadedHeaders[index]
                    );

                    if (!headersMatch) {
                        this.toast.showInfo("Invalid File Format");
                        console.error("Expected headers:", expectedHeaders);
                        console.error("Uploaded headers:", uploadedHeaders);
                        return; // Stop further processing
                    }

                    res.forEach((e, index) => {
                        if (index !== 0) {
                            //console.log("index is ", index)
                            if (this.isInteger(e[0])) {
                                this.excelFileContent.push({
                                    id: e[0],
                                    productName: e[1],
                                    genericName: e[2],
                                    commonName: e[3],
                                    reference: e[4],
                                    minStock:
                                        e[5] !== null &&
                                        e[5] !== undefined &&
                                        e[5] !== ""
                                            ? e[5]
                                            : 0,
                                    productLocation: e[6],
                                });
                            } else {
                                this.invalidIDsBool = true;
                                this.totalInValid++;
                                this.errorMessages();
                                this.errorDialog = true;
                            }
                        }
                    });
                    this.validateStock(true);

                }
            });
        }
    }

    validateStock(isCsvUpload) {
        this.totalInValid = 0;
        this.totalValid = 0;
        this.duplicateRefItems = [];
        this.nullRefItems = [];
        this.nullIDItems = [];
        this.duplicateIDs = [];
        this.invalidMinStockItems = [];
        this.invalidRefItems = [];
        let invalidListItemsStrings: String[] = [];
        let batchNoMap = new Map<string, string>(); // To store batchNo -> first occurrence index
        let currentIDs: number[] = [];

        //console.log("product : ",this.excelFileContent);
        this.checkIDs();
        this.excelFileContent.forEach((v, index) => {

            if (v.id !== null) {
                if (this.isAlphanumeric(v.reference)) {
                    if (batchNoMap.has(v.reference) && v.reference != null) {
                        if (
                            !this.duplicateRefItems.includes(
                                batchNoMap.get(v.reference)!
                            )
                        ) {
                            this.duplicateRefItems.push(v.reference);
                        }
                        this.totalInValid++;
                    } else if (v.reference === "") {
                        this.nullRefItems.push(v.id);
                        this.totalInValid++;
                    } else if (v.reference !== "" && v.reference !== null) {
                        // First occurrence, store its index
                        batchNoMap.set(v.reference, v.reference);
                        this.totalValid++;
                    } else if (v.reference === null) {
                        this.nullRefItems.push(v.id);
                        this.totalInValid++;
                    }
                    /*
            Checklist
              - Duplicate ID (iterate and search for each record)
              - Invalid IDs (Not Numeric)
              - Empty Reference - skip
              - 
            */
                } else {
                    //not an alpha numeric
                    this.invalidRefItems.push(v.id);
                    this.totalInValid++;
                }
                if (v.minStock < 0 || !this.isInteger(Number(v.minStock))) {
                    this.invalidMinStockItems.push(v.id);
                    this.totalInValid++;
                }
            }
        });

        if (this.totalInValid > 0) {
            this.errorMessages();
            this.errorDialog = true;
        } else {
            this.saveFileData(isCsvUpload);
        }
    }

    checkIDs() {
        const seen: number[] = []; // Store unique references
        this.duplicateIDs = []; // Store duplicate ids

        this.excelFileContent.forEach((item) => {
            const id = item.id; // Replace with `item` if array of numbers
            //CHECK FOR DUPLICATES
            if (seen.includes(id)) {
                // Found a duplicate, push the id
                this.duplicateIDs.push(item.id);
                this.totalInValid++;
            } else {
                // First time seeing this reference
                seen.push(id);
            }
        });

    }

    closeErrorDialog() {
        this.errorDialog = false;
        this.existingRecord = false;
    }

    errorMessages(): string[] {

        let messages: string[] = [];

        if (this.existingRecord) {
            messages.push(`Cannot delete, a stock already exists`);
        }

        if (this.invalidIDsBool) {
            messages.push(
                `Invalid Product IDs!. Please Do Not Change Product ID`
            );
        }
        if (this.duplicateIDs.length > 0) {
            messages.push(`Duplicate IDs : ${this.duplicateIDs.join(", ")}`);
        }
        if (this.invalidRefItems.length > 0) {
            messages.push(
                `Invalid Reference IDs : ${this.invalidRefItems.join(", ")}`
            );
        }

        if (this.invalidMinStockItems.length > 0) {
            messages.push(
                `Invalid Min Stock IDs : ${this.invalidMinStockItems.join(
                    ", "
                )}`
            );
        }

        if (this.duplicateRefItems.length > 0) {
            messages.push(
                `Duplicate References : ${this.duplicateRefItems.join(", ")}`
            );
        }
        if (this.nullRefItems.length > 0) {
            messages.push(
                `Empty References IDs : ${this.nullRefItems.join(", ")}`
            );
        }
        return messages;
    }

    isInteger = (value: any): boolean => {
        return Number.isInteger(value);
    };

    isAlphanumeric = (value: any): boolean => {
        return value === "" || /^[A-Za-z0-9]+$/.test(value);
    };

    saveFileData(isCsvUpload) {
        this.duplicateRefItems = [];

        this.productService
            .save(this.excelFileContent)
            .then((res) => {
                this.errorDialog = false;
                this.clearAll();
                if (res.entry) {
                    //console.log("DUPLICATE REF RES ",res);
                    this.duplicateRefItems.push(res.entry);
                    this.errorDialog = true;
                } else {
                    this.toast.handleResponse(res);
                    this.editingRow = null;

                    if (!isCsvUpload) {
                        let eventFirstPara =
                            this.limit * this.finallyClickedPage;
                        this.loadList(eventFirstPara);
                    } else {
                        this.goToFirstLink = 0;
                        this.loadList(0);
                    }

                    // this.loadFullList();
                    this.firstEditingRowTemp = 0;
                }
                //
            })
            .catch((err) => {
                console.error("Error saving CSV:", err);
                this.toast.showError("An error occurred while saving.");
            });
    }

    capitalizeWords(str) {
        let returnStr;
        //console.log("CAPITALIZE WORDS FUNCTION ",str);
        returnStr = str.replace(/\b\w/g, (char) => char.toUpperCase());
        //console.log("CAPITALIZE WORDS return FUNCTION ",returnStr);
        return returnStr;
    }

    // Example usage:

    saveFormData() {
        this.duplicateRefItems = [];

        this.productService
            .saveRowData(this.products)
            .then((res) => {
                //console.log("SAVE FORM DATA ",res);
                this.clearAll();
                if (res.entry) {
                    //console.log("DUPLICATE REF RES ",res);//
                    this.duplicateRefItems.push(res.entry);
                    this.errorDialog = true;
                } else {
                    this.toast.handleResponse(res);
                    this.editingRow = null;
                    let eventFirstPara =
                        Math.floor(this.totalRecords / this.limit) * this.limit;
                    this.goToFirstLink = eventFirstPara;
                    this.loadList(eventFirstPara);
                    // this.loadFullList();
                }
            })
            .catch((err) => {
                console.error("Error saving Form:", err);
            });
    }
    canEdit(row) {
        if (
            row.id === this.firstEditingRowTemp ||
            this.firstEditingRowTemp === 0
        ) {
            this.enableEditButton = false;
            return true;
        } else {
            return false;
        }
    }

    toggleEdit(row) {
        this.clearAll();
        if (this.editingRow === row.id) {
            // Save if already in edit mode
            this.editCurrentRow(row);
            // Exit edit mode
        } else {
            // Enable editing
            this.editingRow = row.id;
            this.firstEditingRowTemp = row.id;
        }
    }
    editCurrentRow(row) {
        this.excelFileContent = [];
        this.excelFileContent.push({
            id: row.id,
            productName: row.product_name,
            genericName: row.generic_name,
            commonName: row.common_name,
            reference: row.reference,
            minStock:
                row.min_stock !== null &&
                row.min_stock !== undefined &&
                row.min_stock !== ""
                    ? row.min_stock
                    : 0,
            productLocation: row.product_location,
        });
        this.validateStock(false);
    }

    clearAll() {
        this.excelFileContent = [];
        this.totalInValid = 0;
        this.invalidMinStockItems = [];
        this.invalidRefItems = [];
        this.duplicateRefItems = [];
        this.totalValid = 0;
    }

    handleProductSave(product) {
        product.product_name = this.capitalizeWords(product.product_name);
        product.generic_name = this.capitalizeWords(product.generic_name);

        this.products = product;
        //console.log("PRODUCTS FROM FORM ", this.products);
        this.saveFormData();
    }

    openDialog() {
        //console.log("open dialog function");
        this.productDialog = true;
    }
    closeDialog() {
        //console.log("close function");
        this.productDialog = false;
    }
    get currency() {
        return this.store.getters.getCurrency;
    }

    isSpecial(item) {
        return item.status === "Deleted";
    }

    rowClass(item) {
        return { "delete-item-raw": this.isSpecial(item) };
    }


    downloadCSV() {
        this.productService.getProducts("", 0, 0, 0).then((data) => {
            this.fullLists = data.records;
            if (this.fullLists.length > 0) {
                this.downloadExcelFileContent = [];

                this.fullLists.forEach((e: any, index) => {
                    this.downloadExcelFileContent.push({
                        id: e.id, // Assign id as index + 1
                        productName: e.product_name,
                        genericName: e.generic_name,
                        commonName: e.common_name,
                        reference: e.reference,
                        minStock:
                            e.min_stock !== null &&
                            e.min_stock !== undefined &&
                            e.min_stock !== ""
                                ? e.min_stock
                                : 0,
                        productLocation: e.product_location,
                    });
                });
            }

            // Define CSV headers
            const headers = [
                "Product ID(*)",
                "Product Name(*)",
                "Generic Name(*)",
                "Common Name(*)",
                "Reference(*)",
                "Min Stock",
                "Product Location",
            ];

            // Filter out only fully empty rows, allowing "0" values
            const filteredData = this.downloadExcelFileContent.filter(
                (item) => {
                    return Object.values(item).some(
                        (value) =>
                            value !== "" &&
                            value !== null &&
                            value !== undefined
                    );
                }
            );

            const rows = filteredData.map((item) => [
                `"${item.id}"`,
                `"${item.productName}"`,
                `"${item.genericName}"`,
                `"${
                    item.commonName !== null && item.commonName !== undefined
                        ? item.commonName
                        : ""
                }"`,
                `"${item.reference == null ? "" : item.reference}"`,
                `"${
                    item.minStock !== null && item.minStock !== undefined
                        ? item.minStock
                        : 0
                }"`,
                `"${
                    item.productLocation !== null &&
                    item.productLocation !== undefined
                        ? item.productLocation
                        : ""
                }"`,
            ]);

            // Join headers and rows with new lines
            const csvString = [headers.join(","), ...rows.map(row => row.join(","))].join("\n");
            const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "products.csv");
            document.body.appendChild(link);

            // Trigger the download
            link.click();
            document.body.removeChild(link);
        });
    }
}
